import { action, computed, makeObservable, observable } from "mobx"
import Stream from "../stream"

class User<T> {
  
  streams: { [ key: string ]: Stream } = {}

  userInfo: T
  constructor(userInfo: T) {
    this.userInfo = userInfo

    makeObservable(this, {
      streams: observable,
      rawStreams: computed,
      initStream: action,
      closeStream: action
    })
  }

  get rawStreams() {
    const streams = []
    for (let streamName in this.streams) {
      const stream = this.streams[streamName]
      if (!stream.mediaStream) continue
      streams.push({ 
        streamName, 
        mediaStream: stream.mediaStream, 
        constraints: stream.constraints 
      })
    }
    return streams
  }

  initStream(streamName: string) {
    const stream = this.streams[streamName]
    if (stream) return stream

    const newStream = new Stream()
    this.streams[streamName] = newStream
    return newStream
  }

  closeStream(streamName: string) {
    const stream = this.streams[streamName]
    if (!stream) return false

    delete this.streams[streamName]  
    return stream.close()
  }

  dispose() {
    for (let key in this.streams) {
      this.streams[key].close()
    }
  }

}

export default User